import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { ModalOfflineDeliveryComponent } from './modal-offline-delivery.component';
import { HelpButtonModule } from '../../help-button/help-button.module';

@NgModule({
  imports: [CommonModule, IonicModule, HelpButtonModule],
  declarations: [ModalOfflineDeliveryComponent],
  providers: [],
})
export class ModalOfflineDeliveryModule {}
